import { render, staticRenderFns } from "./Failed.vue?vue&type=template&id=0299a129&"
import script from "./Failed.vue?vue&type=script&lang=js&"
export * from "./Failed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports